import React, { useState } from "react";
import _default from "react-bootstrap/esm/CardGroup";
import BgEcommerce01 from "../../assets/imgs/banner_ecommerce01.jpg";
import BgEcommerce02 from "../../assets/imgs/banner_ecommerce02.jpg";

export function BoxListEcommerce(props) {
  return (
    <div className="  content_card_audience">
      <h4 className="text-muted text fnt_medium mb-4">
        Disfruta de productos y descuentos exclusivos
      </h4>
      <div className="row">
        <div className="col-sm-6 col-lg-4 mb-4">
          <a
            className="item_ecommerce shadows card"
            href="https://as-mktplce-marketantfrontend-mx-prod.azurewebsites.net"
            target={_default}
          >
            <figure>
              <img src={BgEcommerce01} alt="Ecommerce" />
            </figure>
            <h5 className="mb-0 text fnt_bold text-uppercase">Marketank</h5>
            <p className="paragraph text-muted">Marketplace</p>
          </a>
        </div>
        {/*<div className="col-sm-6 col-lg-4 mb-4">*/}
        {/*  <a*/}
        {/*    className="item_ecommerce shadows card "*/}
        {/*    href="https://www.redvoucheronline.com.mx/"*/}
        {/*    target={_default}*/}
        {/*  >*/}
        {/*    <figure>*/}
        {/*      <img src={BgEcommerce02} alt="Ecommerce" />*/}
        {/*    </figure>*/}
        {/*    <h5 className="mb-0 text fnt_bold text-uppercase">Red voucher online</h5>*/}
        {/*    <p className="paragraph text-muted">Productos y servicios</p>*/}
        {/*  </a>*/}
        {/*</div>*/}
      </div>
    </div>
  );
}
